export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST"
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS"
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL"

export const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST"
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS"
export const USER_REGISTER_FAIL = "USER_REGISTER_FAIL"

export const USER_LOGOUT = "USER_LOGOUT"

export const GET_ALL_USERS_REQUEST = "GET_ALL_USERS_REQUEST"
export const GET_ALL_USERS_SUCCESS = "GET_ALL_USERS_SUCCESS"
export const GET_ALL_USERS_FAIL = "GET_ALL_USERS_FAIL"
export const CLEAR_ALL_USERS = "CLEAR_ALL_USERS"

export const GET_SINGLE_USER_REQUEST = "GET_SINGLE_USER_REQUEST"
export const GET_SINGLE_USER_SUCCESS = "GET_SINGLE_USER_SUCCESS"
export const GET_SINGLE_USER_FAIL = "GET_SINGLE_USER_FAIL"
export const CLEAR_SINGLE_USER = "CLEAR_SINGLE_USER"

export const EDIT_SINGLE_USER_REQUEST = "EDIT_SINGLE_USER_REQUEST"
export const EDIT_SINGLE_USER_SUCCESS = "EDIT_SINGLE_USER_SUCCESS"
export const EDIT_SINGLE_USER_FAIL = "EDIT_SINGLE_USER_FAIL"
export const EDIT_SINGLE_USER_CLEAR = "EDIT_SINGLE_USER_CLEAR"

export const DELETE_SINGLE_USER_REQUEST = "DELETE_SINGLE_USER_REQUEST"
export const DELETE_SINGLE_USER_SUCCESS = "DELETE_SINGLE_USER_SUCCESS"
export const DELETE_SINGLE_USER_FAIL = "DELETE_SINGLE_USER_FAIL"
export const DELETE_SINGLE_USER_CLEAR = "DELETE_SINGLE_USER_CLEAR"

export const GET_SINGLE_USER_ADMIN_REQUEST = "GET_SINGLE_USER_ADMIN_REQUEST"
export const GET_SINGLE_USER_ADMIN_SUCCESS = "GET_SINGLE_USER_ADMIN_SUCCESS"
export const GET_SINGLE_USER_ADMIN_FAIL = "GET_SINGLE_USER_ADMIN_FAIL"
export const CLEAR_SINGLE_USER_ADMIN = "CLEAR_SINGLE_USER_ADMIN"
